import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Loader2, UserPlus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiErrorDetail } from "@/lib/api";

export function AssignAnyUser({ chat, L, onDone, base = "/admin/support-chat" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (q.trim().replace("#", "").length < 2) { setRes([]); return undefined; }
    const t = setTimeout(() => { setBusy(true); api.get(`${base}/users`, { params: { q } }).then(({ data }) => setRes(data)).catch(() => setRes([])).finally(() => setBusy(false)); }, 350);
    return () => clearTimeout(t);
  }, [q, base]);
  const assign = async (u) => {
    try { await api.post(`${base}/chats/${chat.chat_id}/assign`, { agent_id: u.user_id }); toast.success(L(`تم إسناد المحادثة إلى ${u.name}`, `Chat assigned to ${u.name}`)); setOpen(false); onDone(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="h-9 px-3 rounded-xl border border-[#1A5C3A] text-[#1A5C3A] text-sm font-semibold flex items-center gap-1.5 hover:bg-[#E8EFEA]" data-testid={`support-assign-any-${chat.chat_id}`}>
        <UserPlus className="w-4 h-4" />{L("إسناد لأي مستخدم", "Assign to any user")}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="assign-any-dialog">
          <DialogHeader><DialogTitle>{L("إسناد المحادثة لمستخدم", "Assign chat to a user")}</DialogTitle></DialogHeader>
          <label className="flex items-center gap-2 h-11 rounded-xl border border-slate-200 px-3 focus-within:border-[#1A5C3A]">
            <Search className="w-4 h-4 text-slate-400" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={L("ابحث بالاسم أو الإيميل أو الهاتف أو رقم المرجع", "Search name, email, phone or Ref")} className="flex-1 outline-none text-sm bg-transparent" data-testid="assign-any-search" />
            {busy && <Loader2 className="w-4 h-4 animate-spin text-slate-400" />}
          </label>
          <div className="max-h-80 overflow-y-auto space-y-2" data-testid="assign-any-results">
            {q.trim().replace("#", "").length >= 2 && !busy && !res.length && <p className="text-center text-sm text-slate-500 py-6" data-testid="assign-any-empty">{L("لا توجد نتائج", "No results")}</p>}
            {res.map((u) => (
              <button key={u.user_id} type="button" disabled={u.user_id === chat.user_id || u.user_id === chat.agent_id} onClick={() => assign(u)}
                className="w-full text-start rounded-xl border border-slate-200 px-3 py-2.5 hover:border-[#1A5C3A] disabled:opacity-40" data-testid={`assign-any-user-${u.user_id}`}>
                <span className="flex items-center gap-2 font-semibold text-sm">{u.name || u.email}{u.staff && <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#E8EFEA] text-[#1A5C3A]">{L("موظف دعم", "Support agent")}</span>}</span>
                <span className="block text-xs text-slate-500" dir="ltr">{u.email}{u.phone ? ` · ${u.phone}` : ""}{u.wallet_ref ? ` · Ref #${u.wallet_ref}` : ""}</span>
              </button>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
